import { MapContext } from 'contexts/MapContext';
import * as Styled from './styles';
import * as RiIcons from 'react-icons/ri';
import React, { useContext } from 'react';

export function BufferToolMenu() {
  const { bufferDistance, setBufferDistance } = useContext(MapContext);

  return (
    <Styled.BufferBox>
      <Styled.BufferHeader>
        <RiIcons.RiFocus3Line />
        <span>Buffer</span>
      </Styled.BufferHeader>

      <Styled.BufferGroup>
        <label>Distância (metros)</label>
        <input
          type="number"
          min={0}
          step={1}
          value={Number.isFinite(bufferDistance) ? bufferDistance : 0}
          onChange={(e) => {
            const value = Number(e.target.value);
            setBufferDistance(Number.isNaN(value) ? 0 : value);
          }}
          placeholder="Ex.: 500"
        />
      </Styled.BufferGroup>

      <small>Clique em uma feição no mapa para gerar o buffer.</small>
    </Styled.BufferBox>
  );
}
